export default __webpack_public_path__ + "static/screen_landing_portrait-c01e6d9bc506f12a696c99c6b2493ab5.png";